function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React, {useMemo} from "react";
import {getTextColor} from "../../../common/generic-react.functions.js";
import {useReduxWhiteLabelTheme} from "../../../redux/white-label/white-label.hooks.js";
import Icon from "../../atoms/icon/icon.component.js";
import Tooltip from "../../atoms/tooltip/tooltip.component.js";
import {HelpIconChildrenContainer, HelpIconContainer} from "./help-icon.styles.js";
function HelpIcon({
  children,
  text,
  position = "right",
  bgColor = "var(--warningColor)",
  color,
  ...tooltipOptions
}) {
  const [customTheme] = useReduxWhiteLabelTheme();
  const childrenItem = useMemo(() => children && /* @__PURE__ */ React.createElement(HelpIconChildrenContainer, {
    position
  }, children), [children, position]);
  color = useMemo(() => !color && bgColor ? getTextColor(bgColor, customTheme) : "white", [bgColor, color, customTheme]);
  return /* @__PURE__ */ React.createElement(HelpIconContainer, null, position === "right" && childrenItem, /* @__PURE__ */ React.createElement(Tooltip, _extends({}, tooltipOptions, {
    bgColor,
    color,
    text,
    position,
    width: 220
  }), /* @__PURE__ */ React.createElement(Icon, {
    name: "question-circle",
    color: bgColor
  })), position === "left" && childrenItem);
}
export default /* @__PURE__ */ React.memo(HelpIcon);
